<section id="applicationSection" aria-labelledby="app-section-title" class="pb-10 md:pb-36 home-app-section">
  <div class="custom-container font-[_sans-serif] bg-[#f3f7f8] rounded-tl-[70px] rounded-tr-[70px]">
    <div class="flex flex-col md:flex-row justify-between items-center md:items-end gap-20 md:gap-12">
      <div>
        <h2 class="section-title text-3xl sm:text-7xl sm:text-left mt-12 lg:mt-28 lg:mb-2.5" id="app-section-title"
          [innerHTML]="'home.download_mobile_app' | translate | safeHtml">
        </h2>

        <div class="mt-20 grid grid-cols-1 md:grid-cols-3 [grid-auto-rows:max-content] gap-6 md:gap-8">

          <!-- COLUMN 1 -->
          <div class="flex flex-col gap-6 min-h-0">

            <!-- CARD 1 -->
            <div class="bg-white rounded-[36px] text-center p-10 relative">
              <h3 class="text-[#121212] text-3xl font-semibold mb-4"
                [innerHTML]="'promo.secure_bank_title' | translate | safeHtml">
              </h3>

              <div
                class="bg-[rgba(18,18,18,0.05)] rounded-[100px] px-4 py-2 text-md font-semibold text-[rgba(18,18,18,0.5)] inline-block">
                {{ 'promo.secure_bank_subtitle' | translate }}
              </div>
            </div>

            <!-- CARD 2 -->
            <div
              class="bg-[#121212] rounded-[2rem] h-full relative overflow-hidden flex flex-col items-center justify-center">
              <img src="/images/home/bg-cool.png" class="absolute inset-0 w-full h-full object-cover" />

              <div class="z-10 flex flex-col items-center text-center gap-4 m-12">
                <img src="/images/home/chair.png" class="w-[7.625rem] h-[7.625rem]" />

                <h3 class="text-white text-3xl lg:text-4xl font-semibold">
                  {{ 'promo.vip_service_title' | translate }}
                </h3>

                <p class="text-[rgba(255,255,255,0.8)] text-[0.875rem] font-semibold"
                  [innerHTML]="'promo.vip_service_text' | translate | safeHtml">
                </p>
              </div>
            </div>
          </div>

          <!-- COLUMN 2 -->
          <div class="hidden md:block bg-white rounded-[36px] p-8 relative overflow-hidden h-full text-center">
            <h3 class="text-[#121212] text-[2rem] font-semibold mb-4"
              [innerHTML]="'promo.fast_cards_title' | translate | safeHtml">
            </h3>

            <p class="text-[rgba(18,18,18,0.5)] text-sm font-semibold text-center">
              {{ 'promo.fast_cards_text' | translate }}
            </p>

            <img src="/images/home/card-2.png" class="w-full justify-center align-middle" />
          </div>

          <!-- COLUMN 3 -->
          <div
            class="hidden md:flex bg-[#121212] rounded-[36px] p-12 relative overflow-hidden text-white flex-col justify-between">

            <h3 class="text-[32px] lg:text-[2.5rem] leading-tight font-semibold"
              [innerHTML]="'promo.install_app_title' | translate | safeHtml">
            </h3>

            <div class="bg-[rgba(255,255,255,0.05)] rounded-xl flex items-center gap-3 px-3 py-3">
              <img src="/images/home/qr-icon.svg">
              <div class="text-sm font-semibold text-[rgba(255,255,255,0.8)]"
                [innerHTML]="'promo.scan_qr_text' | translate | safeHtml">
              </div>
            </div>

            <div class="flex justify-center">
              <qrcode [qrdata]="qrData()" colorLight="#121212" colorDark="#FFF" [width]="300"
                [errorCorrectionLevel]="'M'">
              </qrcode>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>